import { CohortServerActionCreators } from '../actions/CohortServerActionCreators';
import { dataLoader } from '../../utilities/dataLoader';

export const CohortInitialiser = {
  initialise: () => {
    const initialCohorts = dataLoader('initial-cohorts-data');

    if (initialCohorts) {
      Object.keys(initialCohorts).forEach((cohortPath) => {
        CohortServerActionCreators.updateCohort(initialCohorts[cohortPath]);
      });
    }
  },
};
